"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var SortPagination = function (_a) {
    var posts = _a.posts, getPosts = _a.getPosts;
    // Defined outside of click function as we might need to hide buttons
    var prevAvailable = posts.current_page !== 1;
    var nextAvailable = posts.current_page * posts.per_page < posts.total;
    var paginateNext = function () {
        if (nextAvailable) {
            getPosts(posts.current_page + 1);
        }
    };
    var paginatePrev = function () {
        if (prevAvailable) {
            getPosts(posts.current_page - 1);
        }
    };
    if (!posts) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (!posts.total) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "pagination" },
        react_1.default.createElement("a", { className: classnames_1.default('prev', { hidden: !prevAvailable }), onClick: paginatePrev },
            react_1.default.createElement("i", { className: "cm-icon icon-chevron-left" })),
        react_1.default.createElement("a", { className: classnames_1.default('next', { hidden: !nextAvailable }), onClick: paginateNext },
            react_1.default.createElement("i", { className: "cm-icon icon-chevron-right" }))));
};
exports.default = SortPagination;
